/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_EmptyInputs */

const en_automation_runs_empty = /** @type {(inputs: Automation_Runs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No runs match these filters.`)
};

const pt_br2_automation_runs_empty = /** @type {(inputs: Automation_Runs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma execução corresponde a estes filtros.`)
};

/**
* | output |
* | --- |
* | "No runs match these filters." |
*
* @param {Automation_Runs_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_empty = /** @type {((inputs?: Automation_Runs_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_empty(inputs)
	return pt_br2_automation_runs_empty(inputs)
});